import { useRef } from 'react';

import { AnimatedModal } from 'components/AnimatedModal/AnimatedModal';
import { Button } from 'components/FormComponents';
import { RenewalsSelector } from 'components/RenewalsSelector/RenewalsSelector';

export const AddRenewalCheckModal = ({
  visible,
  onClose,
  renewalConfigs,
  companyChecks,
  onSubmit = () => {},
}) => {
  const renewalsSelectorRef = useRef(null);

  return (
    <AnimatedModal visible={visible} onClose={onClose} title="Add Renewal Check">
      <RenewalsSelector
        ref={renewalsSelectorRef}
        renewalConfigs={renewalConfigs}
        companyChecks={companyChecks}
        onSubmit={onSubmit}
      />
      {renewalConfigs.length < 1 ? (
        <div className="d-flex justify-content-center">
          <p>No renewal types available to add.</p>
        </div>
      ) : (
        <div className="d-flex justify-content-end">
          <Button onClick={() => renewalsSelectorRef.current.submit()}>Add checks to renew</Button>
        </div>
      )}
    </AnimatedModal>
  );
};
